import React from "react";

import { Dialog, IconButton, Typography, DialogContent } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const InfoModal = ({ open, onClose, dialogText, maxWidth = "sm" }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth
      PaperProps={{
        sx: {
          position: "relative",
          textAlign: "center",
          p: 3,
        },
      }}
    >
      <IconButton
        aria-label="close"
        onClick={onClose}
        className="modal-close-button"
      >
        <CloseIcon className="modal-close-icon" />
      </IconButton>

      <DialogContent>
        <Typography className="modal-content-text" sx={{ mt: 3, mb: 2 }}>
          {dialogText}
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default InfoModal;
